$(function(){
    const i18n = window.rngLetterI18n || { label: 'Générer une lettre', generate: 'Générer', copy: 'Copier' };

    $('.rng-letter').replaceWith($(`
        <div class="rng-letter">
            <p>${i18n.label}</p>
            <div class="rng-letter-content">
                <div class="letter-container"></div>
                <button class="generate-button button-yellow">${i18n.generate}</button>
            </div>
        </div>
    `));

    $(document).on('click', '.rng-letter .generate-button', function(){
        const letter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
        const $element = $(this).closest('.rng-letter');
        $element.find('.letter-container').html(letter);
        if (!$element.find('.rng-letter-content').find('.copy-button').length) {
            $element.find('.rng-letter-content').append($(`<button class="copy-button button-yellow">${i18n.copy}</button>`));
        }
    });

    $(document).on('click', '.rng-letter .copy-button', function(){
        const letter = $(this).closest('.rng-letter').find('.letter-container').html();
        navigator.clipboard.writeText(letter);
    });
})
